import React from "react";
import { Typography } from "@mui/material";
import { Field, useFormikContext } from "formik";
import styles from "../../../walkTestSecondStep.module.css";
import { sleepLabelStyle } from "../../sleepReportTheme";

const inputBlockStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minWidth: "200px",
    flex: 1,
};

/**
 * Technologist comment textarea and "Assign to" dropdown using the same
 * Formik + CSS pattern as the 6‑Minute Walk Test form.
 * Must be rendered inside a Formik form.
 */
export default function CommentAssigneeSection({
    commentName = "techComments",
    assignToName = "assignedTo",
    assignToOptions = [],
    assignToLabel = "Assign to",
}) {
    const { errors = {}, touched = {} } = useFormikContext() || {};

    const commentHasError = errors[commentName] && touched[commentName];
    // const assignToHasError = errors[assignToName] && touched[assignToName];

    return (
        <>
            <div style={inputBlockStyle}>
                <Typography style={sleepLabelStyle}>
                    Team Staff Comments
                </Typography>
                <Field
                    name={commentName}
                    as="textarea"
                    rows={4}
                    className={`${styles.inputField} ${styles.textArea} ${
                        commentHasError ? styles.inputError : ""
                    }`}
                    style={{
                        borderRadius: "6px",
                        minHeight: "125px",
                        fontSize: "16px",
                        padding: "12px 16px",
                        boxSizing: "border-box",
                    }}
                />
                {commentHasError && (
                    <div className={styles.errorText}>
                        {errors[commentName]}
                    </div>
                )}
            </div>

            {/* Assign to person is not needed for 6MWT or Sleep reports.
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "24px",
                    flex: "0 0 auto",
                    marginTop: "60px",
                }}
            >
                <Typography style={{ ...sleepLabelStyle, marginBottom: 0 }}>
                    {assignToLabel}
                </Typography>
                <Field
                    name={assignToName}
                    as="select"
                    className={`${styles.sleepFormInputFull} ${
                        assignToHasError ? styles.inputError : ""
                    }`}
                    style={{ width: "240px" }}
                >
                    <option value="">Select Assign to</option>
                    {assignToOptions.map((opt) => {
                        const value = typeof opt === "object" ? opt.value : opt;
                        const label = typeof opt === "object" ? opt.label : opt;
                        return (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        );
                    })}
                </Field>
                {assignToHasError && (
                    <div className={styles.errorText}>
                        {errors[assignToName]}
                    </div>
                )}
            </div>
            */}
        </>
    );
}
